import React from 'react';

const CategoryFilter = ({ categories, activeCategory, onCategoryChange }) => {
  return (
    <div className="flex flex-wrap justify-center gap-3 mb-12">
      {categories.map((category) => (
        <button
          key={category}
          onClick={() => onCategoryChange(category)}
          className={`px-6 py-2.5 rounded-full font-medium transition-all duration-300 text-[17px] ${
            activeCategory === category
              ? 'bg-[#0F6E56] text-white shadow-lg'
              : 'bg-white text-[#2C2C2A] hover:bg-[#F1EFE8] border border-[#E4E1D8]'
          }`}
        >
          {category}
        </button>
      ))}
    </div>
  );
};

export default CategoryFilter;